const ImageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M11.333 5.88892H11.3408"
        stroke="currentColor"
        strokeWidth="1.2963"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.1112L5.88889 8.22233C6.61067 7.52778 7.50044 7.52778 8.22222 8.22233L12.1111 12.1112"
        stroke="currentColor"
        strokeWidth="1.2963"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5557 10.5557L11.3334 9.77787C12.0552 9.08332 12.945 9.08332 13.6668 9.77787L16.0001 12.1112"
        stroke="currentColor"
        strokeWidth="1.2963"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49993 2.64629C4.74307 2.64629 4.0172 2.94695 3.48201 3.48214C2.94683 4.01732 2.64616 4.74319 2.64616 5.50006V12.5002C2.64616 13.2571 2.94683 13.983 3.48201 14.5182C4.0172 15.0533 4.74307 15.354 5.49993 15.354H12.5001C13.257 15.354 13.9829 15.0533 14.518 14.5182C15.0532 13.983 15.3539 13.2571 15.3539 12.5002V5.50006C15.3539 4.74319 15.0532 4.01732 14.518 3.48214C13.9829 2.94695 13.257 2.64629 12.5001 2.64629H5.49993ZM2.56797 2.56809C3.34558 1.79049 4.40024 1.35364 5.49993 1.35364H12.5001C13.5998 1.35364 14.6545 1.79049 15.4321 2.56809C16.2097 3.3457 16.6465 4.40036 16.6465 5.50006V12.5002C16.6465 13.5999 16.2097 14.6546 15.4321 15.4322C14.6545 16.2098 13.5998 16.6467 12.5001 16.6467H5.49993C4.40024 16.6467 3.34558 16.2098 2.56797 15.4322C1.79037 14.6546 1.35352 13.5999 1.35352 12.5002V5.50006C1.35352 4.40036 1.79037 3.3457 2.56797 2.56809Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ImageIcon;
